/** Чистые функции ленты результатов и блока «Доработать» (без React/DOM — тестируются node:test). */
import type { ResultCard } from "./results.ts";

/** Подпись плитки ленты: «модель · качество», иначе «модель · разрешение», иначе одна модель (без «null»). */
export const tileCaption = (g: {
  short_model: string;
  quality: string | null;
  params?: { resolution?: string | null } | null | undefined;
}): string => {
  const extra = g.quality || g.params?.resolution;
  return extra ? `${g.short_model} · ${extra}` : g.short_model;
};

/** Подсказка плитки: подпись по полной модели и размер — только если он есть (у OpenRouter размера нет). */
export const tileTitle = (g: {
  generation_model: string;
  quality: string | null;
  size: string | null;
  params?: { resolution?: string | null } | null | undefined;
}): string => {
  const caption = tileCaption({ short_model: g.generation_model, quality: g.quality, params: g.params });
  return g.size ? `${caption} · ${g.size}` : caption;
};

export type EditRun = NonNullable<ResultCard["edits"]>[number];

/** Статус доработки, которая ещё не закончилась: подпись. */
const WAITING_LABEL: Record<string, string> = { queued: "в очереди", running: "идёт…" };

/** Вид одной доработки в блоке «Доработать»: ждём / готово (превью) / ошибка или отмена. */
export const editRunView = (
  r: Omit<EditRun, "note">,
): { state: "waiting" | "done" | "failed"; label: string; items: { variantId: number; path: string }[] } => {
  if (r.status === "done") {
    return {
      state: "done",
      label: "готово",
      items: r.variants.flatMap((variantId, i) => {
        const path = r.variant_paths[i];
        return path ? [{ variantId, path }] : [];
      }),
    };
  }
  if (r.status === "failed") return { state: "failed", label: r.error ?? "ошибка", items: [] };
  if (r.status === "cancelled") return { state: "failed", label: "отменена", items: [] };
  // незнакомый статус — как есть, а не «в очереди»
  return { state: "waiting", label: WAITING_LABEL[r.status] ?? r.status, items: [] };
};
